/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled, { css } from "styled-components";

import { Tooltip } from "src/components/UI/Tooltip";

interface Props {
  isSelected: boolean;
  handleClick: (a: any) => void;
  children: React.ReactNode;
  tooltipText: string;
  id?: string;
  styles?: React.CSSProperties;
}
export function IconButton({ isSelected, handleClick, children, tooltipText, id, styles }: Props) {
  return (
    <StyledIconButton isSelected={isSelected} onClick={handleClick} id={id} style={styles}>
      <Tooltip tooltipText={tooltipText}>{children}</Tooltip>
    </StyledIconButton>
  );
}

const StyledIconButton = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  cursor: pointer;
  ${({ theme, isSelected }) =>
    isSelected
      ? css`
          color: ${theme.iconButton.selected.color};
          background-color: ${theme.iconButton.selected.backgroundColor};
          &:active {
            color: ${theme.iconButton.selected.activeColor};
          }
        `
      : css`
          color: ${theme.iconButton.color};
          &:hover {
            color: ${theme.iconButton.hoverColor};
            background-color: ${theme.button.hover};
          }
          &:active {
            color: ${theme.iconButton.activeColor};
            background-color: ${theme.iconButton.activeBackgroundColor};
          }
        `};
`;
